export const clampSuggestionIndex = (value: number, suggestionsCount: number): number => {
  if (suggestionsCount <= 0) {
    return 0;
  }

  if (value < 0) {
    return 0;
  }

  if (value >= suggestionsCount) {
    return suggestionsCount - 1;
  }

  return value;
};

export const getNextSuggestionIndex = (currentIndex: number, suggestionsCount: number): number => {
  if (suggestionsCount <= 0) {
    return 0;
  }

  return (currentIndex + 1) % suggestionsCount;
};

export const getPreviousSuggestionIndex = (currentIndex: number, suggestionsCount: number): number => {
  if (suggestionsCount <= 0) {
    return 0;
  }

  return (currentIndex - 1 + suggestionsCount) % suggestionsCount;
};
